import { useEffect } from "react";
import { withRouter } from "react-router-dom";

/** Legacy route — no-preference booking uses the shared Calendly page. */
const RegistrationNoPreferenceCalendlyBooking = ({ history }) => {
  useEffect(() => {
    history.replace("/calendly-booking");
  }, [history]);

  return null;
};

export default withRouter(RegistrationNoPreferenceCalendlyBooking);
